import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Card } from '@tcc/crate';
import CheckboxRadio from 'common/CheckboxRadio';
import ManagementZonesThumbnail from 'manual/ManagementZonesThumbnail';
import ManagementZonesUpgrade from './ManagementZonesUpgrade';
import { managementZonesTypes } from 'constants/scripts';
import { canManualScriptAutomatedZone } from 'product-features/selectors';

const baseString = 'vra-management-zones-quick-view';
const ManagementZonesQuickView = ({
  hasPreviousPrescriptions,
  headerText,
  selectedManagementZonesId,
  onSelectManagementZones,
  zonesData
}) => {
  const canCreateAutomatedZones = useSelector(canManualScriptAutomatedZone);

  const canUpgradeToPremium = zonesData.managementZonesType === managementZonesTypes.GENERATE_ZONES
    && !canCreateAutomatedZones;

  const isSelected = zonesData.id === selectedManagementZonesId;
  const classString = classNames({
    [`${baseString}`]: true,
    isSelected,
    canUpgrade: canUpgradeToPremium
  });
  const isDisabled = (zonesData.managementZonesType === managementZonesTypes.PREVIOUS_PRESCRIPTION  
    && !hasPreviousPrescriptions)
    || canUpgradeToPremium;

  const onSelect = () => {
    if (!isDisabled) {
      onSelectManagementZones(zonesData);
    }
  };
  
  return (
    <div onClick={onSelect}>
      <Card className={classString}>
        <header>
          <CheckboxRadio
            dataTestId={`select-zones-${zonesData.id}`}
            disabled={isDisabled}
            isChecked={isSelected}
            labelText={headerText}
            name='management-zones'
            onChange={onSelect}
            type='radio'
          />
          <p>{zonesData.description}</p>
        </header>
        {canUpgradeToPremium && <ManagementZonesUpgrade />}
        <ManagementZonesThumbnail 
          type={zonesData.managementZonesType} 
          zones={zonesData.zones} 
        />
      </Card>
    </div>
  );
};
ManagementZonesQuickView.propTypes = {
  hasPreviousPrescriptions: propTypes.bool,
  headerText: propTypes.string.isRequired,
  onSelectManagementZones: propTypes.func.isRequired,
  selectedManagementZonesId: propTypes.string.isRequired,
  zonesData: propTypes.object.isRequired
};
export default ManagementZonesQuickView;
